import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { ORDERS_COLLECTION, serverTimestamp, USERS_COLLECTION } from '../../firebase'
import { orderAction } from '../../redux/actions'
import { _idOrderSelector, donePersonOrderSelector, enterPersonOrderSelector, enterTimeOrderSelector, exteriorVehicleWashingPaidOrderSelector, exteriorVehicleWashingOrderSelector, internalVehicleWashingOrderSelector, methodOfPaymentOrderSelector, noteOrderSelector, vehicleColorOrderSelector, vehiclePlatesOrderSelector, vehicleTypeOrderSelector, amountTotalOrderSelector, amountExteriorVehicleWashingOrderSelector, amountInternalVehicleWashingOrderSelector } from '../../redux/selectors'

import './Done.style.css'

import { ReactComponent as IconCancel } from './assets/icon-cancel.svg'

const Done = () => {

    const { id } = useParams()

    const dispatch = useDispatch()

    const history = useHistory()

    const [users, setUsers] = useState([])
    const [usersLoading, setUsersLoading] = useState(false)

    const _idOrder = useSelector(_idOrderSelector)
    const amountTotalOrder = useSelector(amountTotalOrderSelector)
    const amountInternalVehicleWashingOrder = useSelector(amountInternalVehicleWashingOrderSelector)
    const amountExteriorVehicleWashingOrder = useSelector(amountExteriorVehicleWashingOrderSelector)
    const donePersonOrder = useSelector(donePersonOrderSelector)
    const enterPersonOrder = useSelector(enterPersonOrderSelector)
    const enterTimeOrder = useSelector(enterTimeOrderSelector)
    const exteriorVehicleWashingPaidOrder = useSelector(exteriorVehicleWashingPaidOrderSelector)
    const exteriorVehicleWashingOrder = useSelector(exteriorVehicleWashingOrderSelector)
    const internalVehicleWashingOrder = useSelector(internalVehicleWashingOrderSelector)
    const methodOfPaymentOrder = useSelector(methodOfPaymentOrderSelector)
    const noteOrder = useSelector(noteOrderSelector)
    const vehicleColorOrder = useSelector(vehicleColorOrderSelector)
    const vehiclePlatesOrder = useSelector(vehiclePlatesOrderSelector)
    const vehicleTypeOrder = useSelector(vehicleTypeOrderSelector)

    useEffect(() => {

        const getUsers = async () => {
            setUsersLoading(true)
            const snapshot = await USERS_COLLECTION.get()
            const users = []
            snapshot.forEach(doc => {
                users.push(doc.data())
            })
            setUsers(users)
            setUsersLoading(false)
        }

        getUsers()

        const getOrders = async () => {

            const snapshot = await ORDERS_COLLECTION.where('_id', '==', id).get()

            snapshot.forEach(doc => {

                const data = doc.data()

                dispatch(orderAction({
                    _id: data._id,
                    amountTotal: data.amountTotal,
                    amountExteriorVehicleWashing: data.amountExteriorVehicleWashing,
                    amountInternalVehicleWashing: data.amountInternalVehicleWashing,
                    donePerson: data.donePerson,
                    doneTime: data.doneTime,
                    enterPerson: data.enterPerson,
                    enterTime: data.enterTime,
                    exteriorVehicleWashingPaid: data.exteriorVehicleWashingPaid,
                    exteriorVehicleWashing: data.exteriorVehicleWashing,
                    internalVehicleWashing: data.internalVehicleWashing,
                    methodOfPayment: data.methodOfPayment,
                    note: data.note,
                    vehicleColor: data.vehicleColor,
                    vehiclePlates: data.vehiclePlates,
                    vehicleType: data.vehicleType
                }))

            })
        }

        getOrders()

        document.body.style = 'background: #e5e5ea'

    }, [])


    const handleDone = async (e) => {

        e.preventDefault()

        await ORDERS_COLLECTION.doc(id).set({
            _id: _idOrder,
            amountTotal: amountTotalOrder,
            amountExteriorVehicleWashing: amountExteriorVehicleWashingOrder,
            amountInternalVehicleWashing: amountInternalVehicleWashingOrder,
            donePerson: donePersonOrder,
            doneTime: serverTimestamp.now(),
            enterPerson: enterPersonOrder,
            enterTime: enterTimeOrder,
            exteriorVehicleWashingPaid: exteriorVehicleWashingPaidOrder,
            exteriorVehicleWashing: exteriorVehicleWashingOrder,
            internalVehicleWashing: internalVehicleWashingOrder,
            methodOfPayment: methodOfPaymentOrder,
            note: noteOrder,
            vehicleColor: vehicleColorOrder,
            vehiclePlates: vehiclePlatesOrder,
            vehicleType: vehicleTypeOrder
        })
            .then(() => {
                history.push('/')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    return (
        <>
            <div className="done">
                <IconCancel
                    className='done__icon-cancel'
                    onClick={() => history.goBack()}
                />
                <Container fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <div className="done__title">
                                Završi vozilo
                            </div>
                            <div className="done__vehicle-plates">
                                {vehiclePlatesOrder ? vehiclePlatesOrder : '-'}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        {
                            !usersLoading
                                ?
                                users.map(user => {
                                    return (
                                        <Col key={user._id} xs={6} sm={6} md={6} lg={6}>
                                            <button
                                                className={`done__user-button ${donePersonOrder === user.user && "done__user-button--active"}`}
                                                onClick={donePersonOrder === user.user ? () => dispatch(orderAction({ donePerson: '' })) : () => dispatch(orderAction({ donePerson: user.user }))}
                                            >
                                                {user.user}
                                            </button>
                                        </Col>
                                    )
                                })
                                :
                                null
                        }
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            {
                                donePersonOrder === ''
                                    ?
                                    <button
                                        className='done__submit-button'
                                        onClick={() => history.goBack()}
                                    >
                                        Odustani
                                    </button>
                                    :
                                    <button
                                        className='done__submit-button'
                                        onClick={handleDone}
                                    >
                                        Sačuvaj
                                    </button>
                            }
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default Done